<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>Área de Transferência</h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <div mat-dialog-content>
    <mat-progress-bar
      *ngIf="isLoading"
      color="primary"
      mode="indeterminate"
    ></mat-progress-bar>
    <div [hidden]="isLoading">
      <form [formGroup]="formBarcodes">
        <mat-form-field appearance="outline">
            <mat-label>Informe os códigos de barras:</mat-label>
            <textarea formControlName="codigoBarras" matInput rows="5" cols="40" placeholder="Informe um código de barras por linha. Não utilizar virgula."></textarea>
            <mat-hint class="hint">Digite um código de barra por linha, não utilizar virgulas.</mat-hint>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button color="info" mat-dialog-close="cancel">
      Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="barCodesConverter()">Enviar</button>
  </div>
</div>
